import React, { useEffect, useRef, useState } from "react";
import { Modal, Box, Stack, } from "@mui/material";
import ClientChartId from "./ClientChartId";
import { useWindowDimensions } from "./useWindowDimensions.jsx";
import { ScenarioUrl_spec, empty_uuid, ftchPlus, postOptions } from "./Account_urls.jsx";
import ChartSankey from "./Chart_Sankey.jsx";
import { TopOffset } from "./Navbar_bs.jsx";
import { Arrayify } from "../Functions/utils.jsx";

//const ClientChartId = lazy(() => import("./ClientChartId"));


const ChartViewPort = ({
  clientJson,
  show,
  onClose,
  chart,
  onLeft = null,
  onRight = null,
  uuids = [],
  singleUuid = false,
}) => {
  const { winHeight, winWidth } = useWindowDimensions();

  const [dataSets, setDataSets] = useState([]);
  const [client_, setClient_] = useState(null)
  const [dataSet_, setDataSet_] = useState(null)
  const [year_, setYear_] = useState(null)
  const [gridShow, setGridShow] = useState(false)



  const [errmsg, setErrmsg] = useState("")

  const onGridIconClick = (v) => {
    setGridShow(v)
  }


  const getData2 = async (scen_uuid) => {
    // const response = await Axios.get(URL)
    //console.log(scen_uuid);
    //console.log(args);
    var url = ScenarioUrl_spec(clientJson, scen_uuid, "charts", "");
    let body = { "charts": [] }
    {
      chart.map((c, i) => {
        let query = {
          "index": i,
          "query": ScenarioUrl_spec(clientJson, scen_uuid, c.chart, c.arg)
        }
        // console.log(query)
        body.charts.push(query)
      })
    }
    let req = postOptions
    req.body = JSON.stringify(body)
    // console.log(body)
    let json = {}
    try {
      json = await ftchPlus(url, req)
      // console.log(json);
    }
    catch (error) {
      console.log(error.message);
      setErrmsg(error.message)
    }
    return json
  };

  const getData = async () => {
    //console.log(uuids)
    const results = await Promise.all(
      uuids.map(async (uuid, i) => {
        if (!singleUuid || (singleUuid && i === 0)) {
          // Run your async operation
          let json = await getData2(uuid.uuid)
          //console.log(json)
          return json
        }
      }))
    // console.log(results)
    setDataSets(results)
  }


  useEffect(() => {
    setErrmsg("")
    //console.log(chart)

    setDataSets([])
    setDataSet_(null)

    if (show) {
      getData()
    }
  }, [show, chart])

  // const ChartComponents = {
  //   "chart": <ClientChartId children />,
  //   "sankey": <ChartSankey />
  // }

  const getWidth = () => {
    let width = winWidth - 160
    if (!singleUuid && uuids.length > 1) {
      width -= (uuids.length - 1) * 10
      width /= uuids.length
    }
    return width
  }

  const onSetChange = (client, dataSet) => {
    setClient_(client)
    setDataSet_(dataSet)
  }
  const onYearChange = (year) => {
    setYear_(year)
  }

  const myClose = () => {
    setGridShow(false)
    onClose()
  }


  return (
    <Modal
      sx={{ overflow: "scroll", mx: 5, mt: TopOffset }}
      anchor="right"
      open={show}
      onClose={myClose}
    >
      <Box sx={{ mt: 1 }}>
        {chart.map((c, i) => (
          <Stack key={"cvp_stack" + i} direction="row" spacing={2}>
            {Arrayify(uuids).map((u, ui) => (
              <React.Fragment
                key={"cvp_rf:" + i}
              >
                {((singleUuid && ui === 0) || !singleUuid) && (
                  <>
                    {c.chart === "sankeychart" && (
                      <ChartSankey
                        clientJson={clientJson}
                        type={c.chart}
                        args={c.arg}
                        scen_name={u.label}
                        onLeft={chart.length === 1 ? () => { setDataSets([]); onLeft() } : null}
                        onRight={chart.length === 1 ? () => { setDataSets([]); onRight() } : null}
                        width={getWidth()}
                        height={~~((winHeight - 2 * 20 * 4) / 1.5)}
                        dataset={dataSets[ui] === undefined || dataSets[ui][i] === undefined ? null : dataSets[ui][i]}
                        onClose={myClose}
                        dataSet_={dataSet_}
                        client_={client_}
                        onSetChange={onSetChange}
                        year_={year_}
                        onYearChange={onYearChange}
                        showDups={ui === 0}
                      />
                    )}
                    {c.chart !== "sankeychart" && (
                      < ClientChartId
                        clientJson={clientJson}
                        type={c.chart}
                        args={c.arg}
                        onLeft={chart.length === 1 ? () => { setDataSets([]); onLeft() } : null}
                        onRight={chart.length === 1 ? () => { setDataSets([]); onRight() } : null}
                        width={getWidth()}
                        height={~~((winHeight - 2 * 20 * 4) / 1.5)}
                        dataset={dataSets[ui] === undefined || dataSets[ui][i] === undefined ? null : dataSets[ui][i]}
                        onClose={myClose}
                        scen_name={u.label}
                        dataSet_={dataSet_}
                        client_={client_}
                        onSetChange={onSetChange}
                        onGridIconClick={onGridIconClick}
                        gridShow={gridShow}
                        showDups={ui === 0}
                      />
                    )}
                  </>
                )}
              </React.Fragment>
            ))}
          </Stack>
        ))}
      </Box>
    </Modal>
  );
};



export default ChartViewPort;
